import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4af076a7"
import script from "./printVersion.js?vue&type=script&lang=js&external"
export * from "./printVersion.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=4af076a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports